module.exports = __webpack_public_path__ + "201b711154ff1444eb3d4351ce5ec783.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/21.jpg
// module id = 1348
// module chunks = 47